import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "~/components/orcaloops/LoginDoor.tsx";
import { loginHead, validateLoginSearch } from "~/lib/login-search.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * Orcaloops sign-in door.
 *
 * The orca subdomain is a wildcard-prefix host, so `orcaloops.ai/login` (and
 * `orca.test/login`) rewrites to this route at `/orca/login`. Without it the
 * orca host had no reachable login: `/login` rendered the orca not-found and
 * `/auth/sign-in` bounced to a `/flirtmachine/login` that the orca wildcard
 * rewrite turned into a 404.
 *
 * The door is our own v5 card (`components/orcaloops/LoginDoor.tsx`) driven by
 * Clerk's headless sign-in API — email code or Google. The page component is
 * NOT exported, so TanStack's code splitter moves it — and the door, the frame
 * and Clerk's hook with it — into a route chunk instead of the always-loaded
 * entry. The frame's sheet arrives as a `<link>` from `head()`.
 *
 * This is the Orcaloops product door, not an admin-only door — sign-up is open
 * (the footer cross-links to `/orca/sign-up`, itself public to the `/orca`
 * layout guard). After sign-in with no `redirect_url` the user lands on
 * `/orca`, the internal orca root, which the output rewrite renders as `/` on
 * orcaloops.ai.
 *
 * @since 1.0.0
 */

/**
 * The door's `<head>`: `Sign in — Orcaloops`, `noindex`, and the orcaloops
 * frame's stylesheet. Shared with the `$` catch-all.
 *
 * @since 1.0.0
 */
export const loginDoorHead = () => ({ ...loginHead("Orcaloops"), links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/login/")({
  validateSearch: validateLoginSearch,
  head: loginDoorHead,
  component: OrcaLogin,
});

function OrcaLogin() {
  return <LoginPage />;
}
